import type { ApiRequestError } from '@/lib/types'

/**
 * Extract a human-readable message from an HTTP client (axios) error.
 * Prefers the response body's `detail` (string, or a nested `{ message }`),
 * then the transport-level `message`, and finally the supplied fallback.
 * Accepts `unknown` so `catch` / mutation `onError` handlers stay `any`-free.
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  const err = error as ApiRequestError
  const detail = err?.response?.data?.detail
  if (typeof detail === 'string' && detail) return detail
  if (detail && typeof detail === 'object' && detail.message) return detail.message
  return err?.message || fallback
}
